<template>
  <section class="content">
    <vue-table
      :tableData="documents"
      :showEdit="true"
      :showDelete="true"
      :fields="fields"
      :tableTitle="tableTitle">
    </vue-table>
  </section>
</template>
<script>
  import VueTable from '../../helpers/VueTable.vue'
  import library from '../mixins/library'
  export default {
    name: 'LibrarySection',
    mixins: [library],
    components: {
      VueTable
    },
    data () {
      return {
        sectionId: null,
        fields: [
          {
            prop: 'name',
            header: 'Name'
          },
          {
            prop: 'description',
            header: 'Description'
          },
          {
            prop: doc => `<a href="/library/document/${doc.id}">View</a>`,
            header: 'View documents'
          },
          {
            prop: { isRouteLink: true, link: doc => `/library/document/${doc.id}` },
            header: 'View documents'
          }
        ]
      }
    },
    watch: {
      '$route' (newVal, oldVal) {
        this.init()
      }
    },
    computed: {
      documents () {
        return !this.sectionId ? this.allDocuments : this.documentsForSection
      },
      allDocuments () {
        return this.$store.getters['library/documents']
      },
      documentsForSection () {
        return this.allDocuments.filter((doc) => {
          return doc.sectionId === this.sectionId
        })
      },
      tableTitle () {
        return 'Library Documents' + (this.section ? ` - ${this.section.name}` : '')
      },
      allSections () {
        return this.$store.getters['library/sections']
      },
      storeSectionIndex () {
        return this.allSections.findIndex((section) => {
          return section.id === this.sectionId
        })
      },
      section () {
        return this.storeSectionIndex > -1 ? this.allSections[this.storeSectionIndex] : null
      }
    },
    methods: {
      init () {
        this.sectionId = parseInt(this.$route.params.id)
      }
    },
    created () {
      this.init()
    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/modules/library/components/LibrarySection.vue